import React from "react";
import { Button, Typography } from "@mui/material";
function MuiButton({
  viewHeight,
  bgColor,
  borderRadius,
  padding,
  title,
  style,
  ...props
}) {
  return (
    <Button
      {...props}
      sx={{
        height: viewHeight,
        padding: padding,
        backgroundColor: bgColor,
        borderRadius: borderRadius,
        textTransform: "lowercase",
        color: "white",
        ...style,
      }}
    >
      <Typography sx={{ textTransform: "capitalize" }}>{title}</Typography>
    </Button>
  );
}

export default MuiButton;
